<template>
  <div class="h-full ">
    <div class="flex flex-row-reverse flex-wrap mb-10px mr-10px">
      <el-button size="small" type="primary" @click="addLaborSuplies">上传</el-button>
    </div>
    <el-table :data="addLaborSupliesData" border stripe class="mt-20px" :height="tableHeight">
      <el-table-column type="index" label="序号" width="60" show-overflow-tooltip></el-table-column>
      <el-table-column label="劳保用品名称" prop="name" show-overflow-tooltip></el-table-column>
      <el-table-column label="数量" prop="quantity" show-overflow-tooltip></el-table-column>
      <el-table-column label="购买时间" prop="purchasedTime" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ dayjs(scope.row.purchasedTime).format('YYYY-MM-DD') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="检验周期" prop="circle" show-overflow-tooltip></el-table-column>
      <el-table-column label="备注" prop="remark" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" fixed="right" width="280">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEvent('read', scope.row)">查看</el-button>
          <el-button size="mini" type="primary" @click="handleEvent('edit', scope.row)"
            >编辑</el-button
          >
          <el-button size="mini" type="danger" @click="handleEvent('delete', scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="addLaborSupliesTableSizeChange"
      @current-change="addLaborSupliesableCurrentChange"
      :current-page.sync="addLaborSupliesPageConfig.SkipCount"
      :page-size.sync="addLaborSupliesPageConfig.MaxResultCount"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
      :total="addLaborSupliesPageConfig.total"
      class="float-right mt-20px ml-20px clear-both"
    ></el-pagination>
    <AddLaborSuplies
      v-model="addLaborSupliesVisible"
      :checkFrequencyList="checkFrequencyList"
      :contractorId="contractorId"
      :saveLabrRow="saveLabrRow"
      :pageConfigType="pageConfigType"
    />
  </div>
</template>
<script>
import { forEach } from 'lodash'
import { ContractorApi } from '@wiz-api/contractor-management'
import AddLaborSuplies from './addLaborSuplies'

const contractorApi = new ContractorApi()
const checkFrequencyList = [
  {
    displayName: '周',
    code: 1,
    value: 1,
  },
  {
    displayName: '月',
    code: 2,
    value: 2,
  },
  {
    displayName: '季',
    code: 3,
    value: 3,
  },
  {
    displayName: '年',
    code: 4,
    value: 4,
  },
]
export default {
  components: {
    AddLaborSuplies,
  },
  props: {
    contractorId: {
      type: String,
      default: '',
    },
  },
  watch: {
    addLaborSupliesVisible(val) {
      if (!val) {
        this.saveLabrRow = {}
        this.pageConfigType = 'create'
        this.getData()
      }
    },
  },
  data() {
    return {
      saveLabrRow: {},
      pageConfigType: 'create',
      checkFrequencyList,
      addLaborSupliesVisible: false,
      addLaborSupliesData: [],
      addLaborSupliesPageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
        total: 0,
      },
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 108px)'
    },
  },
  created() {
    this.getData()
  },
  methods: {
    handleEvent(type, row) {
      if (type === 'edit' || type === 'read') {
        this.addLaborSupliesVisible = true
        this.pageConfigType = type
        this.saveLabrRow = JSON.parse(JSON.stringify(row))
      } else {
        this.$confirm('请确认是否删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const [err, res] = await contractorApi.deleteLaborInsuranceSupplies(
              this.contractorId,
              row.id
            )
            if (!err) {
              this.$message.success('删除成功')
              this.getData()
            }
          })
          .catch(() => {})
      }
    },
    // 奖励考核信息页码改变
    addLaborSupliesTableSizeChange(MaxResultCount) {
      this.rewardsAndAssessment.MaxResultCount = MaxResultCount
      this.getData()
    },
    // 奖励考核信息页数改变
    addLaborSupliesableCurrentChange(SkipCount) {
      this.rewardsAndAssessmentPageConfig.SkipCount = SkipCount
      this.getData()
    },
    async getData() {
      const data = {
        maxResultCount: this.addLaborSupliesPageConfig.MaxResultCount, // 每页多少条
        skipCount:
          (this.addLaborSupliesPageConfig.SkipCount - 1) *
          this.addLaborSupliesPageConfig.MaxResultCount, // 跳过多少条
      }
      const [err, res] = await contractorApi.getLaborInsuranceSuppliesByPage(
        this.contractorId,
        data
      )
      if (!err) {
        forEach(res.items, (item) => {
          this.checkFrequencyList.forEach((checkFrequency) => {
            if (checkFrequency.code === item.checkFrequencyType) {
              item.checkFrequencyStr = checkFrequency.displayName
            }
            item.circle = `${item.checkFrequency}${item.checkFrequencyStr}`
          })
        })
        this.addLaborSupliesData = res.items
        this.addLaborSupliesPageConfig.total = res.totalCount
      }
    },
    addLaborSuplies() {
      this.addLaborSupliesVisible = true
    },
  },
}
</script>
